/** @jsx jsx */
import { jsx } from "@emotion/core"
import { List } from "@cd2/components"
import { LabelInfo } from "../Components/LabelInfo"
import { IRecord } from "../types/schema"
import { HoverResourceLoader } from "./HoverResourceLoader"
import { buildRoute, eRoutes } from "../routes"
import { format } from "date-fns"
import { HoverCustomerLoader } from "./HoverCustomerLoader"
import { HoverSalesRepLoader } from "./HoverSalesRepLoader"

type IProject = IRecord<"projects", "name" | "dueDate" | "stage" | "percentCertainty"> & {
  customer?: IRecord<"customers", "name">
  sales_rep?: IRecord<"sales_reps", "name">
}

interface IProps {
  id: string
  initialData?: IProject
  renderInlineLink?: "block" | "inline"
  inline?: boolean
}

export function HoverProjectLoader({ id, initialData, renderInlineLink, inline }: IProps) {
  const skeem = window.skeem

  async function loadData() {
    const project = await skeem.fetchOne<IProject>({
      projects: {
        attributes: [
          "name",
          { name: "customer", attributes: ["name"] },
          { name: "sales_rep", attributes: ["name"] },
          "dueDate",
          "stage",
          "percentCertainty",
        ],
        filter: { matches: { id } },
      },
    })
    return project
  }

  return (
    <HoverResourceLoader
      reloadKey={id}
      loadData={loadData}
      initialData={initialData}
      inline={inline}
      renderInlineLink={renderInlineLink}
      viewLink={project => buildRoute(eRoutes["/crm/projects/:id"], { id: project.id })}
      resourceName="Project"
      renderHoverContentTitle={record => record.name}
      renderHoverContent={record => (
        <div>
          <List>
            <LabelInfo labelWidth={80} label="Name" value={record.name} inline />
            <LabelInfo labelWidth={80} label="Stage" value={record.stage} inline />
            <LabelInfo
              labelWidth={80}
              label="Percent Certainty"
              value={record.percentCertainty ? `${record.percentCertainty}%` : "-"}
              inline
            />
            <LabelInfo
              labelWidth={80}
              label="Due Date"
              value={record.dueDate ? format(new Date(record.dueDate), "dd/MM/yy") : null}
              inline
            />
            <LabelInfo
              labelWidth={80}
              label="Customer"
              value={<HoverCustomerLoader id={record.customer?.id} />}
              inline
            />
            <LabelInfo
              labelWidth={80}
              label="Sales Rep"
              value={<HoverSalesRepLoader id={record.sales_rep?.id} initialData={record.sales_rep} />}
              inline
            />
          </List>
        </div>
      )}
      renderTarget={record => <span>{record.name}</span>}
    />
  )
}
